//@@ Internals
import { METRIC_TYPE } from '@src/views/apps/reports/constants'
import { DatabaseWrapper } from '@src/views/apps/reports/features/Database/components/DatabaseWrapper/DatabaseWrapper'

export const EngagementDatabase = () => {
  return <DatabaseWrapper type={METRIC_TYPE.engagement} />
}
